import { Link } from "@/components/Link/Link.component";
import { cn } from "@/lib/utils";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Block, BLOCKS, Inline, INLINES } from "@contentful/rich-text-types";
import { ReactNode } from "react";
import { Typography } from "../Typography/Typography.component";
import { RichTextPropsModel } from "./RichText.model";

export function RichText({
  content,
  className,
  additionalClassName,
  customRenderNode,
}: RichTextPropsModel) {
  const { heading, paragraph, link } = additionalClassName || {
    heading: "",
    paragraph: "",
    link: "",
  };
  const options = {
    preserveWhitespace: true,
    renderNode: {
      [BLOCKS.HEADING_1]: (_node: Block | Inline, children: ReactNode) => (
        <Typography.H1 className={heading}>{children}</Typography.H1>
      ),
      [BLOCKS.HEADING_2]: (_node: Block | Inline, children: ReactNode) => (
        <Typography.H2 className={heading}>{children}</Typography.H2>
      ),
      [BLOCKS.HEADING_3]: (_node: Block | Inline, children: ReactNode) => (
        <Typography.H3 className={heading}>{children}</Typography.H3>
      ),
      [BLOCKS.HEADING_4]: (_node: Block | Inline, children: ReactNode) => (
        <Typography.H4 className={heading}>{children}</Typography.H4>
      ),
      [BLOCKS.HEADING_5]: (_node: Block | Inline, children: ReactNode) => (
        <Typography.H5 className={heading}>{children}</Typography.H5>
      ),
      [BLOCKS.HEADING_6]: (_node: Block | Inline, children: ReactNode) => (
        <Typography.H6 className={heading}>{children}</Typography.H6>
      ),
      [BLOCKS.PARAGRAPH]: (_node: Block | Inline, children: ReactNode) => (
        <Typography.BODY2 className={paragraph}>{children}</Typography.BODY2>
      ),
      [INLINES.HYPERLINK]: (node: Block | Inline, children: ReactNode) => (
        <Link as="re" href={node.data.uri} className={link}>
          {children}
        </Link>
      ),
      ...customRenderNode,
    },
  };

  return (
    <div className={cn("richtext gap-y-md max-md:gap-y-sm grid", className)}>
      {documentToReactComponents(content, options)}
    </div>
  );
}
